import { render, staticRenderFns } from "./MobileNavigation.vue?vue&type=template&id=c5f4d842&scoped=true"
import script from "./MobileNavigation.vue?vue&type=script&lang=js"
export * from "./MobileNavigation.vue?vue&type=script&lang=js"
import style0 from "./MobileNavigation.vue?vue&type=style&index=0&id=c5f4d842&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f4d842",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsSearch: require('/opt/build/repo/components/Icons/Search.vue').default,LayoutHeaderNavItem: require('/opt/build/repo/components/Layout/Header/NavItem.vue').default,LayoutHeaderAccount: require('/opt/build/repo/components/Layout/Header/Account.vue').default,ElementsPopover: require('/opt/build/repo/components/Elements/Popover.vue').default})
